import { render, staticRenderFns } from "./orderGoods.vue?vue&type=template&id=97ba1f5a&scoped=true"
import script from "./orderGoods.vue?vue&type=script&lang=js"
export * from "./orderGoods.vue?vue&type=script&lang=js"
import style0 from "./orderGoods.vue?vue&type=style&index=0&id=97ba1f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ba1f5a",
  null
  
)

export default component.exports